var Backbone = require('backbone');

/*
    Choices Model:
    {
        name: '',
        choices: []
    }
*/

var ChoicesModel = Backbone.Model.extend({
    parse: function(response) {
        response.choices = new Backbone.Collection(response.choices);
        return response;
    },
});

module.exports = ChoicesModel;
